import { CommandCentreVenue } from "../state/UserState";
const currentEnv = process.env.NODE_ENV ?? "development";

class SelectedVenueStore {
  STORAGE_KEY = currentEnv + "ok2pSelectedVenue";

  getVenue(): CommandCentreVenue | undefined {
    let venue = localStorage.getItem(this.STORAGE_KEY);

    if (venue == null) return undefined;

    return JSON.parse(venue);
  }

  storeVenue(venue: CommandCentreVenue) {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(venue));
  }

  clearStore() {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}

export default new SelectedVenueStore();
